import { useState } from 'react'
import { Navigate } from 'react-router-dom'

import {
  browserStorage,
  normalizeOwnerKey,
  readStoredSession,
  type OnboardingSessionState,
} from '@/features/onboarding-chat/state/session'

import { AssessmentScreen } from './AssessmentScreen'
import { CHAT_PATH } from './paths'

export interface AssessmentRouteProps {
  /** The signed-in operator's identity: only their own stored session counts (as in the chat). */
  ownerKey: string | null
  /** Injected in tests. */
  storage?: Storage | null
  now?: () => number
}

/**
 * /onboarding/assessment for the signed-in operator: the stored browser session names the BFF session. With none (a fresh
 * browser, someone else's, an expired one, or no website yet) the person goes back to the chat; so does an assessment the
 * BFF is not ready to give (AssessmentScreen).
 */
export function AssessmentRoute({ ownerKey, storage = browserStorage(), now = Date.now }: AssessmentRouteProps) {
  const [session] = useState<OnboardingSessionState | null>(() => {
    const stored = readStoredSession(storage, now(), normalizeOwnerKey(ownerKey))
    return stored?.url ? stored : null
  })
  if (!session) return <Navigate to={CHAT_PATH} replace />
  return <AssessmentScreen sessionId={session.sessionId} session={session} />
}
